<template>
  <v-card rounded="0" variant="flat">
    <v-card-text>
      <v-row align="center">
        <v-col class="d-none d-md-flex" cols="auto">
          <v-avatar class="mr-4" color="surface-light" size="90">
            <v-img
              v-if="imgResp.src"
              :aspect-ratio="aspectRatio"
              :sizes="imgResp.sizes"
              :src="imgResp.src"
              :srcset="imgResp.srcset"
              alt="Photo of product variant"
            />
          </v-avatar>
        </v-col>

        <v-col cols="12" md="">
          <h5 class="text-h6">{{ name }}</h5>

          <div class="text-body-1 font-weight-bold mt-1">
            Self-paced | Any time
          </div>

          <div v-if="!hideDetails" class="text-body-1 mt-1">
            {{ description }}
          </div>

          <div>
            <ShareLinkButton
              v-if="!hideShareButton"
              :hash="`#h${variant.sku}`"
              variant="text"
            />

            <VariantChips :info-href="infoHref" :variant="variant" />
          </div>
        </v-col>

        <v-col class="text-h5 text-right font-weight-medium" cols="6" md="auto">
          <div class="mx-4" style="width: 120px">{{ listPriceStr }}</div>
        </v-col>

        <v-col class="text-center" cols="6" md="auto">
          <v-btn
            v-if="registerAsLink"
            :append-icon="mdiArrowRight"
            :href="registerHref"
            color="primary"
            target="_blank"
            tile
            variant="flat"
            >Add to Cart</v-btn
          >
          <v-btn
            v-else
            color="primary"
            tile
            @click="
              cartBus.emit({
                eventName: 'item_in_list_add',
                price: variant.list_price_usd,
                priceId: variant.stripe_list_price_id,
                sku: variant.sku,
                type: 'hd'
              })
            "
            >Add to Cart</v-btn
          >
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import { useEventBus } from '@vueuse/core'
import { useImgResponsive } from '#root/lib/img'
import { usePageContext } from '#root/renderer/usePageContext'
import { useVariant } from '#root/lib/useVariant'
import { useVariantHrefs } from '#root/lib/useVariantHrefs'
import type { VariantFeedItem } from '#root/types/variants'
import { mdiArrowRight } from '@mdi/js'

const props = withDefaults(
  defineProps<{
    hideDetails?: boolean
    hideInfoButton?: boolean
    hideShareButton?: boolean
    registerAsLink?: boolean
    value: VariantFeedItem
  }>(),
  {
    hideDetails: false,
    hideInfoButton: false,
    hideShareButton: false,
    registerAsLink: false
  }
)

const { canonicalPaths } = usePageContext()
const variant = toRef(() => props.value)
const { description, image, listPriceStr, name } = useVariant(variant)
const { infoHref, registerHref } = useVariantHrefs(variant, canonicalPaths)

const aspectRatio = 1
const imgResp = useImgResponsive(
  toRef(() => ({
    aspectRatio,
    image: image.value,
    sizes: {
      xs: '200px'
    }
  }))
)

const cartBus = useEventBus('cart')
</script>
